export const taskColors = [
  'task-primary',
  'task-gray',
  'task-red',
  'task-pink',
  'task-yellow',
  'task-green',
  'task-turquoise',
  'task-blue',
  'task-violet'
] as const

export type TaskColor = typeof taskColors[number]

export function isTaskColor(value: unknown): value is TaskColor {
  return typeof value === 'string' && (taskColors as readonly string[]).includes(value)
}
